<template>
    <div class="home">
        <div class="zhi"></div>
        <div class="nianhua"></div>
        <div class="hongbaofei"></div>
        <div class="pub">
            <van-swipe style="height: 40px" vertical :autoplay="2000" :show-indicators="false">
                <van-swipe-item v-for="(content, index) in pubList" :key="index">
                    <van-notice-bar left-icon="volume" style="background-color: #fbba57;">
                        {{content}}
                    </van-notice-bar>
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="page1" :class="showPage1 && showPage2 ? 'hidePage': (showPage1 ? 'hideAnimationPage': '')">
            <div class="shu2">
                <img src="../assets/shuyan.png" class="yanjing" alt="">
                <br>
                <img src="../assets/yuanbao.png" class="yuanbao" alt="">
                <br>
                <img @click="openEnvelopeClick" src="../assets/christmas_share_btn.png" class="open" alt="">
            </div>
        </div>
        <div class="page1" :class="showPage1 && showPage2 ? 'showAnimationPage': 'hidePage'">
            <div class="shu3"></div>
            <div class="txtBox">
                <div class="redResultMoney">
                    <p>您有一个红包未查收,赶紧领取吧！</p>
                    <p>{{money}}<span>元</span></p>
                    <button @click="showPopupClick">提现到账户</button>
                </div>
            </div>
            <div class="bottonBox">
                <!-- 倒计时 -->
                <div class="count-down">
                    <van-count-down styel="color:#FFF" :time="jishi"
                                    format="距离奖励过期还剩： HH 时 mm 分 ss 秒"/>
                </div>
            </div>

            <!-- 弹窗 -->
            <van-popup
                    v-model="showPopup"
                    class="formPopUp">
                <div>
                    <van-cell-group :border="false">
                        <van-field
                                v-model="phone"
                                label="手机号"
                                maxlength="11"
                                placeholder="请输入手机号"
                                error-message=""
                        />

                        <van-field
                                v-model="sms"
                                center
                                clearable
                                maxlength="6"
                                label="短信验证码"
                                placeholder="请输入短信验证码"
                        >
                            <van-button @click="sendClick" slot="button" size="small" type="info">
                                <van-count-down
                                        style="color: #BB1C1D !important; font-family: 'Open Sans', sans-serif !important; font-size: 14px !important; margin-top: 5px !important;"
                                        :time="smsJishi" :format="smsJishi == 0?'发送短信': 'ss 秒'" @finish="finish"/>
                            </van-button>
                        </van-field>
                    </van-cell-group>

                    <van-button @click="submitClick" type="info"
                                style="width: 50%; height: 40px; line-height: 40px; margin-top: 20px;">绑定提现账户
                    </van-button>
                </div>
            </van-popup>
        </div>
    </div>
</template>
<script>
    import cryptoUtil from '../util/cryptoUtil';

    export default {
        name: 'home',
        data() {
            return {
                showPage1: false,
                showPage2: false,
                timer: null,
                jishi: 10 * 60 * 60 * 1000,
                showPopup: false,
                apiUrl: "",
                downloadUrl: "",
                codeMult: 10,
                maxAmout: 10,
                channel: "",
                money: 0,
                phone: '',
                sms: '',
                smsJishi: 0,
                pubList: [],
                tel_reg: /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/
            }
        },
        beforeCreate() {
            this.$http.get('/redpack.json').then((res) => {
                this.apiUrl = res.data.apiUrl === undefined ? 10 : res.data.apiUrl;
                this.downloadUrl = res.data.downloadUrl === undefined ? 10 : res.data.downloadUrl;
                this.codeMult = res.data.codeMult === undefined ? 10 : res.data.codeMult;
                this.pubList = res.data.pubList === undefined ? [] : res.data.pubList;
                this.channel = res.data.channel === undefined ? "" : res.data.channel;
                this.maxAmout = res.data.maxAmout === undefined ? 10 : res.data.maxAmout;
            }).catch((err) => {
                this.$toast('json数据请求失败', err.msg);
            });
        },
        created() {
            let money = localStorage.getItem('money');
            if (money != null) {
                this.money = parseInt(money, 10);
                this.showPage1 = true;
                this.showPage2 = true
            }
        },
        destroyed() {
            clearTimeout(this.timer)
        },
        methods: {
            finish() {
                this.smsJishi = 0
            },
            openEnvelopeClick() {
                this.showPage1 = true;
                let money = Math.floor(Math.random() * (this.maxAmout - 1) + 1);
                this.money = money;
                localStorage.setItem('money', money);
                this.timer = setTimeout(() => {
                    this.showPage2 = true
                }, 800)
            },
            showPopupClick() {
                this.showPopup = !this.showPopup
            },
            // 发送验证码
            sendClick() {
                if (this.tel_reg.test(this.phone)) {
                    let jsonOrStr = {};
                    jsonOrStr.mobile = this.phone;
                    this.$http.post(this.apiUrl+'/api/rp/getCode', {sign: cryptoUtil.RSAEncrypt(jsonOrStr)}, {emulateJSON: true}).then((res) => {
                        if (res.data && res.data.code == 0) {
                            this.smsJishi = 60 * 1000;
                            this.$toast('发送成功');
                        } else {
                            let errData = {100: '手机号格式有误', 102: '短信正在发送中', 103: '您的请求过于频繁'};
                            if (errData[res.data.code] != undefined) {
                                this.$toast('发送失败' + errData[res.data.code]);
                            } else {
                                this.$toast('发送失败');
                            }
                        }
                    }).catch((err) => {
                        this.$toast('发送失败', err.msg);
                    })
                } else {
                    this.$toast(!this.phone ? '手机号不能为空' : '手机号格式不正确');
                }
            },

            // 注册，并跳转下载
            submitClick() {
                if (this.tel_reg.test(this.phone) && this.sms.length == 6) {
                    let jsonOrStr = {};
                    jsonOrStr.mobile = this.phone;
                    jsonOrStr.sixCode = this.sms;
                    jsonOrStr.money = this.money;
                    jsonOrStr.cid = this.channel;
                    jsonOrStr.codeMult = this.codeMult;
                    this.$http.post(this.apiUrl+'/api/rp/getRedPack', {sign: cryptoUtil.RSAEncrypt(jsonOrStr)}, {emulateJSON: true}).then((res) => {
                        if (res.data && res.data.code == 0) {
                            this.$toast('领奖成功');
                            window.location.href=this.downloadUrl;
                        } else {
                            let errData = {
                                100: '手机号格式有误',
                                102: '短信正在发送中',
                                103: '您的请求过于频繁',
                                104: '验证码格式有误',
                                105: "验证码有误",
                                106: '此手机号已领取奖励'
                            };
                            if (errData[res.data.code] != undefined) {
                                this.$toast('领奖失败' + errData[res.data.code]);
                            } else {
                                this.$toast('领奖失败');
                            }
                        }
                    }).catch((err) => {
                        this.$toast('绑定失败', err.msg);
                    });
                } else {
                    this.$toast(!this.phone || !this.sms ? '手机号或验证码不能为空' : '手机号或验证码格式不正确');
                }
            }
        }
    }
</script>

<style>
    .home {
        max-width: 520px;
        width: 100%;
        margin: 0 auto;
        text-align: center;
        height: 100vh;
        position: relative;
        z-index: 10;
    }

    .nianhua {
        position: absolute;
        width: 100%;
        height: 100%;
        text-align: center;
        background: url("../assets/nianhua.png") no-repeat center bottom;
        background-size: 30% auto;
        z-index: 30;
        background-position-y: 90%;
    }

    .hongbaofei {
        position: absolute;
        width: 100%;
        height: 100%;
        text-align: center;
        background: url("../assets/hb.png") no-repeat center bottom;
        z-index: 40;
        animation: feihbAnimate 5s infinite;
    }

    .page1 {
        width: 100%;
        height: 100vh;
        position: absolute;
        width: 100%;
        height: 100vh;
    }

    .zhi {
        position: absolute;
        z-index: 50;
        left: 10px;
        background: url("../assets/zhi.png") no-repeat center center;
        background-size: 80% auto;
        width: 100%;
        height: 60%;
        animation: zhiAnimate 5s infinite;
    }

    .shu2 {
        background: url("../assets/shu2.png") no-repeat center center;
        background-size: 100%;
        width: 100%;
        height: 300px;
        margin-top: 30vh;
        position: relative;
        z-index: 99;
    }

    .shu2 img.yanjing {
        width: 14%;
        margin-top: 110px;
        margin-right: 8px;
        animation: zhenyanAnimate 1.5s infinite;
    }

    .shu2 img.yuanbao {
        width: 50%;
        margin-top: 55px;
        animation: rotateAnimate 0.4s infinite;
    }

    .shu2 img.open {
        width: 200px;
        height: 50px;
        margin-top: 10px;
        animation: scaleAnimate 1s infinite;
    }

    .hideAnimationPage {
        animation: hidePageAnimate 0.8s infinite;
        animation-iteration-count: 1
    }

    .hidePage {
        display: none;
    }

    .pub {
        position: absolute;
        top: 40px;
        width: 100%;
        height: 40px;
        z-index: 200;
    }

    .van-notice-bar {
        width: 80%;
        margin: 0 auto;
        border-radius: 20px;
        background-color: rgba(250, 226, 140, 0.8) !important;
        font-size: 15px !important;
        color: rgb(224, 41, 45) !important;
        font-weight: bold !important;
    }

    .bottonBox {
        position: absolute;
        bottom: 20px;
        width: 100%;
        height: 30px;
        z-index: 200;
    }

    .count-down {
        color: #FFF;
        font-weight: bold;
        font-size: 15px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        background: #fbba57;
        padding: 5px 10px;
        width: 80%;
        margin: 0 auto;
    }

    .van-count-down {
        font-size: 15px !important;
        color: #FFF !important;
        font-weight: bold !important;
    }

    .shu3 {
        background: url("../assets/shu.png") no-repeat top center;
        background-size: 60%;
        background-position-y: 150px;
        z-index: 220;
        width: 100%;
        height: 100%;
        position: absolute;
    }

    .txtBox {
        position: absolute;
        z-index: 270;
        width: 100%;
        height: 300px;
        top: 390px;
    }

    .txtBox .redResultMoney {
        color: #FFFF06;
        padding: 0 20px;
        box-sizing: border-box;
        background: rgba(114, 16, 1, 0.4);
        width: 80%;
        border-radius: 5px;
        margin: 0 auto;
        padding: 20px;
    }

    .txtBox .redResultMoney p {
        font-size: 15px;
        font-weight: bold;
    }

    .txtBox .redResultMoney p:nth-child(2) {
        font-size: 60px;
        text-align: center;
        margin: 10px 0;
        letter-spacing: 1px;
    }

    .txtBox .redResultMoney p span {
        font-size: 18px;
        margin-left: 2px;
    }

    .txtBox Button {
        width: 60%;
        height: 40px;
        background: linear-gradient(to bottom, #fcdf87 0%, #fbba57 100%);
        border: none;
        border-radius: 5px;
        position: relative;
        border-bottom: 5px solid #fbba57;
        color: #BB1C1D;
        font-weight: 600;
        font-family: 'Open Sans', sans-serif;
        font-size: 16px;
        text-align: center;
        box-shadow: 0px 3px 0px rgba(0, 0, 0, .2);
        cursor: pointer;
    }

    .txtBox Button:active {
        box-shadow: 0px 2px 0px rgba(0, 0, 0, .2);
        top: 1px;
    }

    .van-popup, .van-cell-group, .van-cell {
        background-color: rgb(179, 9, 46) !important;
        color: #FFF !important;
    }

    .van-field__control {
        color: #FFFFFF !important;
    }

    .formPopUp {
        width: 80%;
        max-width: 400px;
        padding: 20px 0;
        box-sizing: border-box;
        border-radius: 5px;
    }

    .formPopUp Button {
        background: linear-gradient(to bottom, #fcdf87 0%, #fbba57 100%);
        border: none;
        border-radius: 5px;
        position: relative;
        border-bottom: 5px solid #fbba57;
        color: #BB1C1D;
        font-weight: 600;
        font-family: 'Open Sans', sans-serif;
        font-size: 14px;
        text-align: center;
        box-shadow: 0px 3px 0px rgba(0, 0, 0, .2);
        cursor: pointer;
    }


    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #e1e1e1 !important;
    }

    ::-moz-placeholder { /* Firefox 19+ */
        color: #e1e1e1 !important;
    }

    :-ms-input-placeholder { /* IE 10+ */
        color: #e1e1e1 !important;
    }

    :-moz-placeholder { /* Firefox 18- */
        color: #e1e1e1 !important;
    }

    @keyframes hidePageAnimate {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

    @keyframes feihbAnimate {
        0% {
            opacity: 0;
            background-size: 20% auto;
            background-position-y: 0vh;
        }
        70% {
            opacity: 1;
            background-size: 80% auto;
            background-position-y: 20vh;
        }
        100% {
            opacity: 0;
            background-size: 50% auto;
            background-position-y: 50vh;
        }
    }

    @keyframes zhiAnimate {
        0% {
            opacity: 0;
            background-size: 20% auto;
            bottom: 0vh;
        }
        70% {
            opacity: 1;
            background-size: 80% auto;
            bottom: 50vh;
        }
        100% {
            opacity: 0;
            background-size: 120% auto;
            bottom: 60vh;
        }
    }

    @keyframes zhenyanAnimate {
        0% {
            opacity: 0;
        }
        25% {
            opacity: 1;
        }
        50% {
            opacity: 0;
        }
        100% {
            opacity: 0;
        }
    }

    @keyframes scaleAnimate {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.2);
        }
        100% {
            transform: scale(1);
        }
    }

    @keyframes rotateAnimate {
        0% {
            transform: rotate(7deg);
        }
        50% {
            transform: rotate(-7deg);
        }
        100% {
            transform: rotate(7deg);
        }
    }
</style>
